import { Tooltip } from 'react-tooltip';
import React from 'react';
const SportnetTooltip = ({ content, visible = true, children = null, }) => {
    const id = React.useId().replace(/[:]/g, '');
    return visible ? (React.createElement(React.Fragment, null,
        React.createElement("span", { id: `tooltip-${id}`, "data-tooltip-place": "top", "data-tooltip-position-strategy": "fixed" }, children),
        React.createElement(Tooltip, { anchorSelect: `#tooltip-${id}`, style: { zIndex: 1000 } }, content))) : (React.createElement(React.Fragment, null, children));
};
export default SportnetTooltip;
